import { Theme } from '@mui/material/styles/createTheme';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  bugReportItemWrapper: {
    padding: theme.spacing(1),
    borderRadius: '4px',
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
    justifyContent: 'space-between',
    border: `1px solid ${theme.palette.grey[500]}`,

    '&:hover': {
      border: `1px solid ${theme.palette.primary.main}`,
      cursor: 'pointer',
    },
    '& svg': {
      color: theme.palette.error.main,
    },
  },
  bugReportItemInfo: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
}));
